export default __webpack_public_path__ + "static/media/weather-app.f15f288a.png";